import React, {forwardRef, useEffect, useRef, useState} from 'react';
import {Animated, Easing, LayoutAnimation, StyleSheet, TouchableOpacity, UIManager, View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {BottomSheet} from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import {windowWidth} from '../../constants';
import SVG from '../../imports/svg';
import {selectrootalerttype} from '../../selectors/AlertSelector';
import {CustomText} from '../text/Text';
import { showAlert } from '../../actions/AlertActions';
let animationFrameId;
const CustomBottomSheet = forwardRef(
  (
    {
      open,
      snapPoints,
      children,
      onClose,
      defaultSnap,
      expandOnContentDrag = true,
      onSpringEnd,
      onSpringStart,
      isTransparent = false,
      ...restProps
    },
    ref,
  ) => {
    const {modalProps} = useSelector(state => selectrootalerttype(state));
    const icon = modalProps?.icon;
    const message = modalProps?.message;
    const title = modalProps?.title;
    const opacity = useRef(new Animated.Value(0)).current;
    const dispatch = useDispatch()

    const customOnSpringStart = () => {
      animationFrameId = requestAnimationFrame(() => {
        if (ref && ref?.current) {
          if (ref && ref?.current && ref?.current?.height == 1) {
            setTimeout(() => {
              onClose();
            }, 200);
          }
        }
      });
      onSpringStart && onSpringStart();
      if (ref.current?.height > 1) {
        const element = document.documentElement;
        element.style.setProperty('--rsbs-backdrop-bg', 'transparent');
      } else if (!isTransparent) {
        const element = document.documentElement;
        element.style.setProperty('--rsbs-backdrop-bg', 'rgba(0,0,0,0.4)');
      }
    };

    const customOnSpringEnd = () => {
      onSpringEnd && onSpringEnd();
      cancelAnimationFrame(animationFrameId);
      if (ref.current?.height > 1 && !isTransparent) {
        const element = document.documentElement;
        element.style.setProperty('--rsbs-backdrop-bg', 'rgba(0,0,0,0.4)');
      } else {
        const element = document.documentElement;
        element.style.setProperty('--rsbs-backdrop-bg', 'transparent');
      }
    };

    const switchBorderColor = () => {
      switch (icon) {
        case 'orangeExclamation':
          return '#FFBA4B';
        case 'redExclamation':
          return '#F87878';
        case 'greenTick':
          return '#61D215';
        case 'blueExclamation':
          return '#2BBEF2';
        default:
          return '#F87878';
      }
    };


    const show = useRef(
      Animated.timing(opacity, {
        toValue: 1,
        duration: 200,
        useNativeDriver: true,
        easing: Easing.ease,
      }),
    ).current;
  
    const hide = useRef(
      Animated.timing(opacity, {
        toValue: 0,
        duration: 200,
        useNativeDriver: true,
        easing: Easing.ease,
      }),
      () => {
        dispatch(
          showAlert({
            id: '',
            modalProps: {
              icon: '',
              title: '',
              message: '',
            },
          }),
        );
      }
    ).current;


    useEffect(()=>{
      if ( title ){
        show.start();
        setTimeout(() => {
          hide.start();
        }, 5000);
      }
    },[title])

    return (
      <BottomSheet
        expandOnContentDrag={expandOnContentDrag}
        ref={ref}
        defaultSnap={defaultSnap}
        snapPoints={snapPoints}
        onDismiss={expandOnContentDrag ? onClose : undefined}
        open={open}
        {...{...restProps}}
        onSpringEnd={customOnSpringEnd}
        onSpringStart={customOnSpringStart}
        sibling={
          title ? (
            <Animated.View
              style={[
                styles.body,
                {
                  opacity: opacity,
                },
              ]}>
              <TouchableOpacity
                style={[styles.container, {borderColor: switchBorderColor()}]}
                onPress={() => {
                  hide.start();
                }}
                activeOpacity={1}>
                {!!icon && <SVG name={icon} width={24} height={24} />}

                <View style={styles.textContainer}>
                  {!!title && (
                    <CustomText
                      color={'#2F3F53'}
                      size={14}
                      txtAlign="right"
                      font={'700'}
                      selectable={false}>
                      {title}
                    </CustomText>
                  )}
                  {!!message && (
                    <CustomText
                      color={'#2F3F53'}
                      size={12}
                      font={'400'}
                      style={styles.text}
                      selectable={false}>
                      {message}
                    </CustomText>
                  )}
                </View>
              </TouchableOpacity>
            </Animated.View>
          ) : null
        }>
        {children}
      </BottomSheet>
    );
  },
);

export default CustomBottomSheet;

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    zIndex: 100,
    width: 300,
    height: 56,
  },
  container: {
    backgroundColor: '#fff',
    borderRadius : 18 , 
    borderWidth : 1 ,
    opacity: 1,
    borderRadius: 12,
    marginTop : 16 , 
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'row-reverse',
    paddingVertical: 12,
    paddingHorizontal: 12,
    width: windowWidth -32 , 
  },
  textContainer : {
    marginRight : 8 ,
    width : windowWidth -92 , 
  },
  body: {
    width: windowWidth,
    position: 'absolute',
    top: 5,
    zIndex: 99999999999999,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: 'black',
    fontSize: 14,
    marginHorizontal: 12,
    textAlign: 'right',
  },
});
